// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__kz6Q5","smallLoader":"style_smallLoader__6lpgx"};